/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { getBoardId } from '@jira/router-resources__utils/src/getBoardId.tsx';
import { fetchJSWReports } from '../../../services/sidebar/jsw-reports-sidebar-navigation/fetchJSWReports.tsx';
import type { JiraSoftwareReport } from '../../../services/sidebar/jsw-reports-sidebar-navigation/types.tsx';

export const staticSidebarJSWReportsResource: RouteResource<JiraSoftwareReport[] | null> =
	createResource<JiraSoftwareReport[] | null>({
		type: 'JIRA_SOFTWARE_REPORTS',
		// oxlint-disable-next-line no-explicit-any
		getKey: ({ match, query }: { match: any; query: any }) => {
			const boardId = getBoardId(match, query);
			return boardId ? `board-${boardId}` : 'none';
		},
		getData: async ({ match, query }) => {
			const boardId = getBoardId(match, query);
			if (boardId == null) {
				return null;
			}
			const response = await fetchJSWReports(boardId);
			return response?.reports;
		},
		maxAge: 5 * 60 * 1000,
		isCritical: true,
	});
